/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import { VERSION } from '../version';
import router from '../router';

// Plugins
import vuetify from '@/plugins/vuetify';
import dialogPlugin from '@/plugins/dialog';
import libPlugin from '@/plugins/mode.js';
import i18n from '@/plugins/i18n';
import { vuetifyProTipTap } from '@/plugins/vuetifyprotiptap.js';

export function registerPlugins(app) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
        release: `respeak-expert-${import.meta.env.VITE_SENTRY_ENVIRONMENT}@${VERSION}`,
        telemetry: false,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
            // Sentry.feedbackIntegration({
            //     // Additional SDK configuration goes in here, for example:
            //     colorScheme: 'system',
            //     isNameRequired: true,
            //     isEmailRequired: true,
            // }),
        ],
        // Tracing
        tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            'http://localhost:5173',
            /^https:\/\/expert-test.respeak\.io/,
            /^https:\/\/expert.respeak\.io/,
        ],
        denyUrls: [/@vue\/runtime-core\/dist\/runtime-core\.esm-bundler\.js/],
        // Session Replay
        replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    // .use(router)
    app.use(router)
        .use(vuetify)
        .use(createPinia())
        .use(Vue3Toastify, {
            autoClose: 3000,
            theme: 'colored',
            clearOnUrlChange: false,
            position: 'bottom-right',
            bodyClassName: 'toast-body',
        })
        .use(dialogPlugin)
        .use(libPlugin)
        .use(i18n)
        .use(vuetifyProTipTap);
}
